import { observer } from "mobx-react-lite";
import React from "react";
import Link from "@mui/material/Link";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import i18nStore from "../../i18n/store";
import { loginPath } from "../../routes/paths";

const SuccessResetPasswordMsg = observer(() =>  {
    const navigate = useNavigate();
    const translations = i18nStore.getTranslations;

    return (
        <Container component="main" maxWidth="md">
            <CssBaseline />
            <Box
                sx={{
                    marginTop: 8,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Typography component="h1" variant="h5" sx={{ mb: 4 }}>
                    {translations._resetPassword.passwordChanged}
                </Typography>

                <Typography variant="subtitle1" component="p">
                    {translations.returnTo}&nbsp;
                    
                    <Link
                        href={loginPath}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            navigate(loginPath);
                        }}
                        sx={{
                            "&:hover": {
                                cursor: "pointer",
                            },
                        }}
                    >
                        {translations.toLoginPage}
                    </Link>.
                </Typography>
            </Box>
        </Container>
    );
});


export default SuccessResetPasswordMsg;
